import { render, staticRenderFns } from "./CoverageChecker.vue?vue&type=template&id=1546bf7a&scoped=true"
import script from "./CoverageChecker.vue?vue&type=script&lang=js"
export * from "./CoverageChecker.vue?vue&type=script&lang=js"
import style0 from "./CoverageChecker.vue?vue&type=style&index=0&id=1546bf7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1546bf7a",
  null
  
)

export default component.exports